// built-in imports
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { AiFillHome } from "react-icons/ai";
import { FaUserTie } from "react-icons/fa";
import { SiCodeproject } from "react-icons/si";
import { HiMail } from "react-icons/hi";

// internal imports
import { Wrapper, BottomMenue } from "./menu-bar.styles";
import { Theme, SocialBar } from "../index";
import { useAppContext } from "../../layout/layout";

const MenuBar = () => {
  const { pathname } = useLocation();
  const { isMenuBar } = useAppContext();

  return (
    <Wrapper>
      <AnimatePresence>
        {isMenuBar && (
          <motion.div
            initial={{ y: "20vh" }}
            animate={{
              y: 0,
            }}
            transition={{
              type: "tween",
            }}
            exit={{ y: "20vh" }}
          >
            <SocialBar />
            <BottomMenue>
              <div>
                <a href="#hero">
                  <AiFillHome
                    className={`icon ${pathname === "/" ? "active" : ""}`}
                  />
                </a>
              </div>
              <div>
                <a href="#about">
                  <FaUserTie
                    className={`icon ${pathname === "/about" ? "active" : ""}`}
                  />
                </a>
              </div>
              <div className={`theme-container icon`}>
                <Theme />
              </div>
              <div>
                <a href="#experiences">
                  <SiCodeproject
                    className={`icon ${
                      pathname === "/experiences" ? "active" : ""
                    }`}
                  />
                </a>
              </div>
              <div>
                <a href="#contact">
                  <HiMail
                    className={`icon ${
                      pathname === "/contact" ? "active" : ""
                    }`}
                  />
                </a>
              </div>
            </BottomMenue>
          </motion.div>
        )}
      </AnimatePresence>
    </Wrapper>
  );
};
export default MenuBar;
